import React, { useMemo } from "react";
import KioskFilters from "./KioskFilters";
import KioskMetricCard from "./KioskMetricCard";
import KioskSessionTable from "./KioskSessionTable";
import {
  buildAdministrationSummary,
  filterAdministrationRows,
  flattenKioskGroups,
} from "../hooks/kioskDashboard.helpers";

const Administration = ({ data, filters, onFilterChange, onReport, loading, error, onReload }) => {
  const groups = data && Array.isArray(data.groups) ? data.groups : [];
  const allRows = useMemo(() => flattenKioskGroups(groups), [groups]);
  const rows = useMemo(() => (
    filterAdministrationRows(allRows, filters)
  ), [allRows, filters]);
  const summary = useMemo(() => buildAdministrationSummary(groups, rows), [groups, rows]);
  const userOptions = useMemo(() => {
    const seen = new Map();
    allRows.forEach(row => seen.set(row.usuarioId, { usuarioId: row.usuarioId, nombre: row.nombre }));
    return [...seen.values()];
  }, [allRows]);
  const selectedUserId = filters && filters.usuarioId ? Number(filters.usuarioId) : null;
  const measurementRows = useMemo(() => (
    selectedUserId ? allRows.filter(row => row.usuarioId === selectedUserId) : allRows
  ), [allRows, selectedUserId]);
  const measurementOptions = useMemo(() => measurementRows.map(row => ({
    sessionId: row.sessionId,
    usuarioId: row.usuarioId,
    nombre: row.nombre,
    fecha: row.fecha,
  })), [measurementRows]);

  return (
    <div className="space-y-4">
      <KioskFilters
        filters={filters}
        onChange={onFilterChange}
        userOptions={userOptions}
        measurementOptions={measurementOptions}
        showStatus
      />

      {error && (
        <div className="flex items-center justify-between gap-3 rounded-xl border border-rose-100 bg-rose-50 px-4 py-3 text-sm text-rose-700" role="alert">
          <span>No se pudo cargar la administración del kiosko.</span>
          <button type="button" onClick={onReload} className="font-bold underline">Reintentar</button>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        <KioskMetricCard label="Sesiones programadas" value={loading ? "…" : summary.scheduledSessions} icon="calendar" />
        <KioskMetricCard label="Sesiones completadas" value={loading ? "…" : summary.completedSessions} icon="completed" accent="green" />
        <KioskMetricCard label="Pendientes" value={loading ? "…" : summary.pendingSessions} icon="clock" accent="amber" />
        <KioskMetricCard label="Capacidad" value={loading ? "…" : `${summary.occupied}/${summary.capacity}`} icon="users" />
        <KioskMetricCard label="Grupos" value={loading ? "…" : summary.groups} icon="groups" />
        <KioskMetricCard label="Empleados" value={loading ? "…" : summary.employees} icon="users" />
      </div>

      <KioskSessionTable rows={rows} onReport={onReport} />
    </div>
  );
};

export default Administration;
